export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/twoD.a5c7577.svg";